import CsrFe from "24broker-csr";

window.onload = function () {
    let a = CsrFe.csr({
        prefix: 'data-csr',
        api: {
            forms: {
                submit: '/csr/form',
                utility: '/csr/utility'
            }
        },
        errors:{
            all:false
        }
    });
}
